module.exports = __webpack_public_path__ + "img/1.752d08df.jpg";